
export const careerPalette = {
  primary: '#2A3349',
  blue: '#20BBFC',
  yellow: '#FFB714',
  brown: '#845C1A',
  darkblue: '#2C95D5'
}